<template>
  <QDialog
    :value="value"
    position="left"
    full-height
    transition-show="slide-right"
    transition-hide="slide-left"
    content-class="vehicle-result-filter-drawer__backdrop-inner"
    aria-labelledby="vehicle-product-filter-drawer-title"
    @input="$emit('input', $event)"
  >
    <QCard class="lease-inclusion-dialog vehicle-result-filter-drawer vehicle-result-filter-drawer--panel column no-wrap full-height">
      <QCardSection class="vehicle-result-filter-drawer__header column q-pa-md q-pt-md q-pb-none full-width">
        <div class="row items-center no-wrap full-width vehicle-result-filter-drawer__header-nav justify-end">
          <QBtn
            rounded
            class="font-nunito calculator-dialog-close vehicle-result-filter-drawer__close-btn"
            flat
            :icon-right="closeIconCircle"
            size="16px"
            color="primary"
            align="left"
            @click="$emit('input', false)"
          >
            Close
          </QBtn>
        </div>
        <p
          id="vehicle-product-filter-drawer-title"
          class="
            text-primary
            font-nunito
            text-weight-bold
            q-pa-none q-mt-sm
            lease-inclusion-title
            vehicle-result-filter-drawer__filters-title
          "
        >
          Filters
        </p>
      </QCardSection>
      <QCardSection class="vehicle-result-filter-drawer__body col q-pa-md q-pt-none scroll">
        <div class="vehicle-result-filter-drawer__payments-block">
          <p class="text-primary text-weight-bolder vehicle-result-filter-drawer__section-label">Lease Term</p>
          <LeaseTermOptions
            :value="draftLeaseTerm"
            :options="leaseTermOptions"
            hide-label
            full-width-buttons
            @input="draftLeaseTerm = $event"
          />
        </div>
        <div class="vehicle-result-filter-drawer__divider" aria-hidden="true" />
        <div class="vehicle-result-filter-drawer__payments-block">
          <RepaymentOptions
            class="vehicle-result-filter-drawer__repayment-options"
            :value="draftRepayment"
            :is-active="true"
            full-width-buttons
            @input="draftRepayment = $event"
          />
        </div>
        <div class="vehicle-result-filter-drawer__divider" aria-hidden="true" />

        <CalculatorButton
          outlined
          rounded
          class="col-12 calculator-button full-width"
          label="Lease inclusions"
          @click="$emit('leaseInclusion')"
        />

        <div class="vehicle-result-filter-drawer__footer-spacer" aria-hidden="true" />
      </QCardSection>
      <QCardSection class="vehicle-result-filter-drawer__detail-footer q-pt-lg full-width no-border">
        <CalculatorButton
          color="primary"
          has-chevron-icon
          outlined
          class="col-12 calculator-button full-width"
          rounded
          label="Update search"
          @click="submitDrawer"
        />
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QBtn } from 'quasar';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';
import LeaseTermOptions from '../LeaseTermOptions';
import RepaymentOptions from '../RepaymentOptions';
import CalculatorButton from '../CalculatorButton';

/**
 * Mobile filters drawer for the vehicle product page (lease term, repayments, lease inclusions).
 * Uses draft state until "Update search"; parent applies URL + committed filters on @apply.
 */
export default {
  name: 'VehicleProductFilterDrawer',
  components: {
    QDialog,
    QCard,
    QCardSection,
    QBtn,
    LeaseTermOptions,
    RepaymentOptions,
    CalculatorButton
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    repayment: {
      type: String,
      default: 'weekly'
    },
    leaseTerm: {
      type: Object,
      default: null
    },
    leaseTermOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      closeIconCircle: evaCloseCircleOutline,
      /** Local copies until "Update search" — avoids immediate route sync closing the dialog. */
      draftRepayment: this.repayment,
      draftLeaseTerm: this.leaseTerm
    };
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.seedDraftFromProps();
      }
    }
  },
  methods: {
    seedDraftFromProps() {
      this.draftRepayment = this.repayment;
      this.draftLeaseTerm = this.leaseTerm ? { ...this.leaseTerm } : null;
    },
    submitDrawer() {
      this.$emit('apply', {
        repayment: this.draftRepayment,
        leaseTerm: this.draftLeaseTerm
      });
      this.$emit('input', false);
    }
  }
};
</script>
